module.exports = __webpack_public_path__ + "img/UTFLIG-6.d4c7a679.jpg";